<template>
    <div class="container-fluid py-3 px-4">

      <div class="border border-1 rounded-3 p-3 mb-3 ">
        <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
            <i class="bi bi-file-earmark-spreadsheet-fill display-4  text-primary"></i>
          <div>
            <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
              HISTORIAL
            </p>
            <p class="mb-0 tituloResaltado fs-4 fw-bold">
              LISTADO DE TODA LA INFORMACION
            </p>
          </div>
        </div>
      </div>
        <!-- Filtros -->
        <div class="row align-items-end mb-3 mx-0">
            <div class="border border-1 rounded-3 p-3 d-flex flex-wrap align-items-end gap-3">

                <!-- Campo Año -->
                <div class="col-lg-2 col-md-4 col-12">
                    <label class="form-label tamaño">AÑO:</label>
                    <input v-model="perAno" type="text" class="form-control" placeholder="INGRESE EL AÑO" 
                     @input="perAno = perAno.replace(/\s+/g, '')"/>
                </div>
                

                <!-- Campo Mes -->
                <div class="col-lg-3 col-md-4 col-12">
                    <label class="form-label tamaño">MES:</label>
                    <select v-model="perMes" class="form-select w-100">
                        <option disabled value="0">-- SELECCIONAR MES --</option>
                        <option v-for="mes in meses" :key="mes.value" :value="mes.value">
                            {{ mes.label }}
                        </option>
                    </select>
                </div>
                 <div class="col-lg-2 col-md-4 col-12">
                    <label class="form-label tamaño">BUSCADOR:</label>
                  <input v-model="busqueda" type="text" class="form-control" placeholder="APELLIDOS/DNI/EMPRESA" 
                   @input="busqueda = busqueda.replace(/\s+/g, ''); filtro()" @keydown.space.prevent/>
                </div>

                <!-- Botón Buscar -->
                <div class="col-auto">
                    <button
                        class="btn btn-light boton-estiloCuadrado d-flex align-items-center justify-content-center border border-success"
                        @click="obtenerHistorial">
                        <i class="bi bi-search"></i>
                    </button>
                </div>
                <!-- Botón Excel -->
                <div class="col-auto">
                    <button
                         :disabled="!excelBien" class="btn btn-success boton-estiloCuadrado d-flex align-items-center justify-content-center"
                        @click="descargarExcelHistorial" >
                        <i class="bi bi-file-earmark-excel"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- Tabla -->
        <div class="border border-1 rounded-3 p-3 mb-2">
            <div class="table-responsive">
                <table class="table table-bordered mb-3">
                    <thead class="reducirTamaño">
                        <tr class="bg-solimano text-white text-center text-nowrap">
                            <th><i class="bi bi-boxes"></i></th>
                            <th>APELLIDOS Y NOMBRES</th>
                            <th>N° DNI</th>
                            <th>EMPRESA</th>
                            <th>CENTRO</th>
                            <th>SUBCENTRO</th>
                            <th>SUBSUBCENTRO</th>
                            <th> DETALLE DEL DISPOSITIVO</th>
                            <th> ESTADO </th> 
                            <th>MONTO DE ALQUILER</th>
                            <th>MONTO</th>
                            <th>PERIODO</th>
                            <th>DETALLE TÉCNICO</th>
                        </tr>
                    </thead>

                    <tbody class="text-center align-middle reducirTamaño text-nowrap">
                        <tr v-for="(item, index) in copiasPaginadas" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.apellidosNombres }}</td>
                            <td>{{ item.nroDocumento }}</td>
                            <td>{{ item.hisEmpresa }}</td>
                            <td>{{ item.hisDesCentroCosto }}</td>
                            <td>{{ item.hisDesSubCentro }}</td>
                            <td>{{ item.hisDesSubSubCentro }}</td>
                            <td>{{ item.nombreDispositivo }}</td>
                            <td>{{ item.hisDesTipDispositivo }}</td>
                            <td>{{ item.hisMonAlquiler }}</td>
                            <td>{{ item.hisMonto }}</td>
                            <td>{{ item.hisperiodo }}</td>
                            <td>{{ item.hisDetalleTecnico }}</td> 
                        </tr>

                        <tr v-if="informacion.length === 0">
                            <td colspan="13" class="text-center text-muted">No hay información disponible.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- Paginación -->
        <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
            <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
                <i class="bi bi-chevron-double-left"></i>
            </button>

            <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
                <i class="bi bi-chevron-left"></i>
            </button>

            <span class="pagination-info">Página {{ currentPage }} de {{ totalPages }}</span>

            <button class="btn btn-outline-primary btn-sm" @click="currentPage++"
                :disabled="currentPage === totalPages">
                <i class="bi bi-chevron-right"></i>
            </button>

            <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
                :disabled="currentPage === totalPages">
                <i class="bi bi-chevron-double-right"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "HistorialdeReportes",
    data() {
        return {
            informacion: [],
            idTrabajador: "",
            periodo: "",
            perMes: "0",
            perAno: "",
            busqueda: "",
            currentPage: 1,
            itemsPerPage: 50,
            excelBien: false,
            excelHistorialDocumento: null,
            meses: [
                { value: "01", label: "Enero" },
                { value: "02", label: "Febrero" },
                { value: "03", label: "Marzo" },
                { value: "04", label: "Abril" },
                { value: "05", label: "Mayo" },
                { value: "06", label: "Junio" },
                { value: "07", label: "Julio" },
                { value: "08", label: "Agosto" },
                { value: "09", label: "Septiembre" },
                { value: "10", label: "Octubre" },
                { value: "11", label: "Noviembre" },
                { value: "12", label: "Diciembre" },
            ],
        };
    },

    created() {
        this.cambiarEstadoNavbar();
        this.idTrabajador = localStorage.getItem("idTrabajdor");
    },
    computed: {

        HistorialFiltrado() {
            if (!this.busqueda) return this.informacion;
            const texto = this.busqueda.toLowerCase();
            return this.informacion.filter(
                (d) =>
                    d.apellidosNombres?.toLowerCase().includes(texto) ||
                    d.hisEmpresa?.toLowerCase().includes(texto) ||
                    String(d.nroDocumento).toLowerCase().includes(texto)
            );
        },


        copiasPaginadas() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            return this.HistorialFiltrado.slice(start, start + this.itemsPerPage);
        },


        totalPages() {
            return Math.ceil(this.HistorialFiltrado.length / this.itemsPerPage) || 1;
        },
        
    },

    methods: {
        cambiarEstadoNavbar() {
            this.$store.dispatch("acciones/CambioNavbar", true);
        },

        obtenerHistorial() {
            this.periodo = `${this.perAno}${this.perMes}`;
            this.reporteHistorialExcel()
            console.log("Periodo:", this.periodo);

            this.axios
                .get(`Tecnologia/HistorialAsignacion?idTrabajador=${this.idTrabajador}&periodo=${this.periodo}`)
                .then((r) => {
                    console.log("Datos recibidos:", r.data);
                    this.informacion = r.data;
                })
                .catch((error) => {
                    console.error("Error al obtener historial:", error);
                });
        },
        reporteHistorialExcel() {
             this.excelBien = false;
            this.axios
                .get(`ReportesExcel/ReporteHisAsistencia?idTrabajador=${this.idTrabajador}&periodo=${this.periodo}`, { responseType: "blob" })
                .then((r) => {
                    this.excelHistorialDocumento = r.data;
                     this.excelBien = true;
                    console.log(r.data);
                    
                });
        },

        descargarExcelHistorial() {
            var fileURL = window.URL.createObjectURL(
                new Blob([this.excelHistorialDocumento])
            );
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", "Historial_Dispositivos.xlsx");
            document.body.appendChild(fileLink);

            fileLink.click();
        },
          filtro() {
      this.currentPage = 1;
    },
    },
};
</script>

<style scoped>
.boton-estiloCuadrado {
    padding: 0.4rem 0.60rem;
    cursor: pointer;
}

.buscar-estiloCuadrado {
    border-radius: 0;
    font-size: 0.65rem;
    background-color: transparent;
    /* Fondo transparente */
}

.tabla-estiloCompreso {
    padding: 0.3rem 0.55rem;
}

.input-group {
    max-width: 350px;
}

.row.mb-3 {
    margin-bottom: 1rem !important;
}

.tabla-estiloCompreso {
    padding: 0.3rem 0.55rem;
}

.reducirTamaño {
    font-size: 0.65rem;
}

.bg-solimano {
    background: #1565c0;
}

.bg-solimano-table {
    background: #0080c8;
}

.btn-solimano {
    background: #0080c8;
}

.tamaño {
    font-size: 0.65rem;

    font-weight: 800;
    color: #002c5d;
}

table,
tr,
h6 {
    page-break-inside: avoid;
}
</style>
